export default __webpack_public_path__ + "static/media/sword.bc3a320a.gif";